import React, { useEffect, useState } from 'react'
import { Link, usePage } from '@inertiajs/react'
import turstpilot from '../../images/trustpilot.png';
import acceptpayment from '../../images/accepted-payments.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faEnvelope, faLocationCrosshairs, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faGooglePlusG, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';


function Footer() {

    const { menu, settings } = usePage().props as any;
    const footerMenuTrustLegal = menu.find((m: any) => m.name === 'trust and legal');
    const menuItemsTrustLegal = footerMenuTrustLegal?.items || [];

    const footerMenuCustomerSupport = menu.find((m: any) => m.name === 'customer support');
    const menuItemsCustomerSupport = footerMenuCustomerSupport?.items || [];

    const topFunction = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    const [showBackToTop, setShowBackToTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 200) {
                setShowBackToTop(true);
            } else {
                setShowBackToTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <footer className="container-fluid footer-section">
            <div className="container">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="footer-box">
                            <div className="mob-d-flex-foot">
                                <div className="foot-logo">
                                    <Link href="/"><img src={settings.footer_logo} alt="footer logo" /></Link>
                                </div>

                                <div>
                                    <div className="rating">
                                        <Link href="#"><img src={turstpilot} alt="turstpilot" /></Link>
                                    </div>
                                    <div className="foot-cta dex-hidden">
                                        <p>Need help choosing? Call our boiler team now</p>
                                        <Link href="#" className="call-btn">
                                            <span className="phone-icon">
                                                <FontAwesomeIcon icon={faPhone} />
                                            </span>
                                            {settings.phone}
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-info">
                                <div className="item">
                                    <span className="icon"><FontAwesomeIcon icon={faPhone} /></span>
                                    <a href={`tel:${settings.phone}`}>{settings.phone}</a>
                                </div>

                                <div className="item">
                                    <span className="icon"><FontAwesomeIcon icon={faEnvelope} /></span>
                                    <a href={`mailto:${settings.email}`}>{settings.email}</a>
                                </div>

                                <div className="item">
                                    <span className="icon"><FontAwesomeIcon icon={faLocationCrosshairs} /></span>
                                    <a href="https://maps.app.goo.gl/YrCRicA6uzdDA1SK7" target="_blank">United Kingdom</a>
                                </div>
                            </div>

                            <div className="foot-cta mob-hidden">
                                <p>Need help choosing? Call our boiler team now</p>
                                <a href="#" className="call-btn">
                                    <span className="phone-icon">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </span>
                                    {settings.phone}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-6">
                        <div className="footer-box">
                            <h3 className="foot-title">Trust & Legal</h3>
                            <ul className="foot-link">
                                {menuItemsTrustLegal.map((item: any, index: number) => (
                                    <li key={index}><Link href={'/' + item.url}>{item.label}</Link></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-3 col-6">
                        <div className="footer-box">
                            <h3 className="foot-title">Customer Support</h3>
                            <ul className="foot-link">
                                {menuItemsCustomerSupport.map((item: any, index: number) => (
                                    <li key={index}><Link href={'/' + item.url}>{item.label}</Link></li>
                                ))}
                            </ul>
                            <div className="foot-payment mob-hidden">
                                <h3>Accepted Payments</h3>
                                <img src={acceptpayment} alt="acceptpayment" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="copyright-section">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="foot-payment dex-hidden col-6">
                            <h3>Accepted Payments</h3>
                            <img src={acceptpayment} alt="acceptpayment" />
                        </div>
                        <div className="foot-social col-sm-5 col-7">
                            <ul>
                                {settings.social_icons?.map((social: any, index: number) => (
                                    <li key={index}>
                                        <a href={social.url} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={social.icon}
                                                alt="social"
                                                width={20}
                                                height={20}
                                            />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="text col-sm-7">
                            <p>© Copyright 2026 CombiBoiler. All rights reserved. Design by <Link href="https://www.acsius.com/"
                                target="_blank">ACSIUS</Link></p>
                        </div>
                    </div>
                </div>
            </div>
            <button onClick={topFunction} id="myBtn" className={showBackToTop ? 'd-block' : 'd-none'} title="Go to top"><FontAwesomeIcon icon={faAngleUp} /></button>
        </footer>
    )
}

export default Footer